import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfig } from '../app-config';
import { IPlanRepository } from './Iplan.repository';
import { ApiResponse, Plan, PlanRequest } from './models';


@Injectable({ providedIn: 'root' })
export class PlanRepository implements IPlanRepository {

	constructor(private readonly httpClient: HttpClient, @Inject(APP_CONFIG) private readonly config: AppConfig) { }

	savePlan(planRequest: PlanRequest): Observable<ApiResponse<Plan>> {
		return this.httpClient.post<ApiResponse<Plan>>(this.config.domainPatientAPI + '/api/cases/createcase', planRequest);
	}

	getPlan(planGuid: string): Observable<ApiResponse<Plan>> {
		const params = new HttpParams().set('id', planGuid);
		return this.httpClient.get<ApiResponse<Plan>>(this.config.domainPatientAPI + '/api/cases/getcase', { params: params });
	}

	updatePlan(plan: Plan): Observable<ApiResponse<any>> {
		return this.httpClient.post<ApiResponse<Plan>>(this.config.domainPatientAPI + '/api/cases/updatecase', plan);
	}

	deletePlan(planGuid: string): Observable<ApiResponse<any>> {
		const params = new HttpParams().set('id', planGuid);
		return this.httpClient.post<ApiResponse<any>>(this.config.domainPatientAPI + '/api/cases/DeleteCase', null, { params: params });
	}

}
